<div class="container-fluid mt-2 ">
    <div class="row">
        <div class="col-12 col-sm-12 col-md-4 p-2">
            <home-baseform (onNext)="onNext($event)" (clearAll)="onClear()" >
            </home-baseform>
        </div>
        <div class="col-12 col-sm-12 col-md-8 p-1">
            <home-products  *ngIf='out'>
            </home-products>
            <home-expandedform [product]="product" (submitProduct)="submit($event)" *ngIf='!out'>
            </home-expandedform>
        </div>
    </div>
</div>